<template>
    <b-container fluid class="bg-light" style="min-height: 110vh">
        <b-row>
            <b-col md="4" lg="3" class="px-0">
                <b-navbar class="bg-secondary navbar-dark border-secondary border-bottom">

                    <div @click="toggleMenu" class="pt-2">
                        <!--<icon name="bars" class="text-light"></icon>-->
                    </div>

                    <div style="min-height: 40px"></div>
                </b-navbar>
                <div class="menu" v-if="showMenu">
                    <b-list-group>
                        <b-list-group-item  :to="{name:'pageDashboard'}">
                            <i class="fa fa-tachometer" aria-hidden="true"></i>

                            <!--<icon name="home" class="float-left mt-1"/>-->
                            <span>داشبرد</span>
                        </b-list-group-item>
                        <b-list-group-item  :to="{name:'pageUser'}">
                            <!--<icon name="user" class="float-left mt-1"/>-->
                            <span>کاربران</span>
                        </b-list-group-item>
                        <b-list-group-item  :to="{name:'pageOrderStatus'}">
                            <!--<icon name="credit-card" class="float-left mt-1"/>-->
                            <span>سفارشات</span>
                        </b-list-group-item>
                        <b-list-group-item  :to="{name:'pageSetting'}">
                            <!--<icon name="cogs" class="float-left mt-1"/>-->
                            <span>تنظیمات</span>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </b-col>
            <b-col class="px-0">
                <b-navbar class="bg-white border-bottom">
                    <b-navbar-brand>{{title}}</b-navbar-brand>

                    <a href="javascript:void(0)" @click="logout" class=" text-dark mr-auto mt-2">
                        <!--<icon name="power-off"></icon>-->
                    </a>
                </b-navbar>
            </b-col>
        </b-row>
        <slot></slot>
    </b-container>
</template>

<script>

    import FormInput from "bootstrap-vue/es/components/form-input/form-input";

    export default {
        components: {FormInput},
        name: "main-layout",
        props: ['title'],
        data() {
            return {
                showMenu: false,
            }
        },
        methods: {
            toggleMenu() {

                this.showMenu = !this.showMenu;
            },
            logout() {
                this.$auth.logout({
                    makeRequest: true,
                    redirect: '/login',
                });
            },

        }
    }
</script>
<style scoped>
    .col-menu {
        min-height: calc(100vh - 56px);
    }

    .nav-link {
        color: #f8f9fa !important;
    }

    .router-link-active {
        background-color: #495057;
    }

    .nav-item:hover .nav-link {
        background-color: #545b62;
    }


</style>

<style>

    .menu {
        margin: -15px 5px 5px 5px;
        position: absolute;
        z-index: 10000001;
        width: calc(100% - 10px);
    }
</style>


// WEBPACK FOOTER //
// src/components/layouts/MainLayout.vue